import React from 'react';
import classNames from 'classnames';
import styles from './label.module.css.js';

const Label = ({ className, htmlFor, children, 'data-testid': dataTestId }) => (React.createElement("label", { className: classNames(styles.label, className), htmlFor: htmlFor, "data-testid": dataTestId }, children));

export { Label };
